export const getBloodSugarData = (store) => store.BloodSugarRecord.data;
export const getInitialDate = (store) => store.BloodSugarRecord.date;
export const getNoramalDate = (store) => store.BloodSugarRecord.normalDate;
export const getSelectedList = (store) => store.BloodSugarRecord.selectedList;
export const getBloodSugarFlag = (store) =>
  store.BloodSugarRecord.bloodSugarFlag;
export const getBSSubmitFlag = (store) => store.BloodSugarRecord.submitFlag;
export const getListFlag = (store) => store.BloodSugarRecord.listFlag;
